module.exports = __webpack_public_path__ + "static/media/8250971-394x394.c69497a7.png";